import fetchExpresso from 'utility/fetchExpresso';

function assertOk(response, message) {
    if (response.status !== 200) {
        throw new Error(message);
    }
}

export async function getRegistrationPageData(eventId) {
    const [registrationResponse, questionsResponse] = await Promise.all([
        fetchExpresso(`/apiv2/events/${eventId}/registration`),
        fetchExpresso(`/apiv2/events/${eventId}/registration/questions`),
    ]);

    assertOk(registrationResponse, 'Unable to load registration settings');
    assertOk(questionsResponse, 'Unable to load checkout questions');

    const registration = await registrationResponse.json();
    const { questions } = await questionsResponse.json();

    return { registration, questions };
}

export async function updateRegistrationMode(eventId, mode) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/registration`, {
        method: 'PUT',
        body: {
            mode,
            firstName: undefined,
            lastName: undefined,
            email: undefined,
        },
    });

    assertOk(response, 'Something went wrong');
}

export async function updateRegistrationQuestionsSort(eventId, sort) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/registration/questions`, {
        method: 'PUT',
        body: { sort },
    });

    assertOk(response, 'Unable to change order');
}

export async function getAttendeeProducts(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/registration/attendee-products`);

    assertOk(response, 'Unable to load attendee products');

    return response.json();
}

export async function updateAttendeeProducts(eventId, productIds) {
    const response = await fetchExpresso(
        `/apiv2/events/${eventId}/registration/attendee-products`,
        {
            method: 'PUT',
            body: {
                products: productIds,
            },
        },
    );

    assertOk(response, 'Unable to save attendees');
}

export async function updateRequiredAttendeeInfo(eventId, firstName, lastName, email) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/registration`, {
        method: 'PUT',
        body: {
            mode: undefined,
            firstName,
            lastName,
            email,
        },
    });

    assertOk(response, 'Unable to save attendee information');
}
